import { inject, injectable } from "inversify";
import { ServiceResponse, IApiClient, IApiClientId } from "@se/platform";
import { IFBSFeedbackServiceId, IFBSFeedbackService } from "../interfaces/fbsFeedbackService";
import { FBSConfig } from "../../configuration/FBSConfig";
import { BrowserDetails } from "../../models/BrowserDetails";

@injectable()
class FBSFeedbackService implements IFBSFeedbackService {

    constructor(
        @inject(IApiClientId) private apiClient: IApiClient,
        @inject(FBSConfig) private fbsConfig: FBSConfig
    ) { }

    public async SubmitFBSFeedbackForm(FeedbackDetails: string, NodeId: number, accessToken: string): Promise<ServiceResponse<string>> {

        var payload: any = {
            'PageUrl': location.toString(),
            'FeedbackDetails': FeedbackDetails,
            'NodeId': NodeId,
            'VisitorBrowser': new BrowserDetails()
        };

        const response = await this.apiClient.Post<string, string>(this.fbsConfig.FeedbackSubmissionUrl, ``, payload, accessToken);
        return response;
    }
};

export { FBSFeedbackService }